module.exports = __webpack_public_path__ + "static/media/29EUNOG8.ea2fb613.jpg";